import React, { useEffect, useState } from 'react';
import { Typography, Table, Button, Modal, Form, Input, InputNumber, Switch, Space, message } from 'antd';
import { PlusOutlined, EditOutlined } from '@ant-design/icons';
import api from '../api';

// Admin > Project Types: the types a Folder or Project can be given (New Class
// Order, Client Request ...). Never deleted: a type made inactive is no longer
// offered, and folders and projects that have it keep it. Listed in Order,
// then by name.

export default function ProjectTypesAdminPage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(null);     // null | { type }
  const [saving, setSaving] = useState(false);
  const [form] = Form.useForm();

  const load = () => {
    setLoading(true);
    api.get('/api/project-types')
      .then((r) => setRows(r.data || []))
      .catch(() => message.error('Failed to load project types.'))
      .finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const open = (type) => {
    form.resetFields();
    form.setFieldsValue(type ? { name: type.Name, sort_order: type.SortOrder } : { name: '' });
    setModal({ type });
  };
  const save = async () => {
    let v;
    try { v = await form.validateFields(); } catch { return; }
    setSaving(true);
    try {
      if (modal.type) await api.put(`/api/project-types/${modal.type.ID}`, { name: v.name, sort_order: v.sort_order ?? 0 });
      else await api.post('/api/project-types', { name: v.name });
      setModal(null);
      load();
    } catch (err) {
      message.error(err.response?.data?.error || 'Save failed.');
    } finally {
      setSaving(false);
    }
  };
  const toggle = (t) => api.put(`/api/project-types/${t.ID}`, { is_active: !t.IsActive })
    .then(load).catch(() => message.error('Failed to update.'));

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <Typography.Title level={4} style={{ margin: 0 }}>Project Types</Typography.Title>
        <Button type="primary" icon={<PlusOutlined />} onClick={() => open(null)}>Add Type</Button>
      </div>
      <Table
        rowKey="ID" size="small" loading={loading} dataSource={rows} pagination={false}
        locale={{ emptyText: 'No project types yet.' }}
        columns={[
          { title: 'Order', dataIndex: 'SortOrder', key: 'SortOrder', width: 80, align: 'right' },
          { title: 'Name', dataIndex: 'Name', key: 'Name' },
          { title: 'Folders', dataIndex: 'FolderCount', key: 'FolderCount', width: 90, align: 'right' },
          { title: 'Projects', dataIndex: 'ProjectCount', key: 'ProjectCount', width: 90, align: 'right' },
          { title: 'Active', dataIndex: 'IsActive', key: 'IsActive', width: 90,
            render: (v, t) => <Switch size="small" checked={!!v} onChange={() => toggle(t)} /> },
          { title: '', key: 'edit', width: 80, align: 'right',
            render: (_, t) => <Button size="small" icon={<EditOutlined />} onClick={() => open(t)}>Edit</Button> },
        ]}
      />

      <Modal maskClosable={false} title={modal?.type ? 'Edit Type' : 'Add Type'} open={!!modal} onOk={save}
        onCancel={() => setModal(null)} confirmLoading={saving} okText="Save" destroyOnClose>
        <Form form={form} layout="vertical" style={{ marginTop: 8 }}>
          <Space align="start" size={12}>
            <Form.Item name="name" label="Name" rules={[{ required: true, message: 'Required' }]}>
              <Input maxLength={100} style={{ width: 300 }} />
            </Form.Item>
            {modal?.type && (
              <Form.Item name="sort_order" label="Order"><InputNumber precision={0} style={{ width: 90 }} /></Form.Item>
            )}
          </Space>
        </Form>
      </Modal>
    </div>
  );
}
